import { render, staticRenderFns } from "./local-timezone-badge.vue?vue&type=template&id=7b55007e"
import script from "./local-timezone-badge.vue?vue&type=script&lang=js"
export * from "./local-timezone-badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports